import { useEffect, useRef, useState } from "react";
import { ThemeProvider } from "styled-components";
import { GlobalStyle } from "./globalStyles";
import Home from "./Pages/Home";
import Header from "./components/Header/index";
import Footer from "./components/Footer/index";
import ScrollToTop from "./components/ScrollToTop/index";

const lightTheme = {
  background: "#eff7f9",
  text: "#0a0b10",
  nav: "#35353f",
  nav2: "#3f3d56",
  white: "#ffffff",
  purple: "#803bec",
  pink: "#e5a1f8",
};

const darkTheme = {
  background: "#0a0b10",
  text: "#ffffff",
  nav: "#17171f",
  nav2: "#2a2a38",
  white: "#f5f5f7",
  purple: "#8f6cff",
  pink: "#ff9cf0",
};

function App() {
  const [themeMode, setThemeMode] = useState("light");
  const homeRef = useRef(null);
  const aboutRef = useRef(null);
  const servicesRef = useRef(null);
  const contactRef = useRef(null);

  const sectionRefs = {
    home: homeRef,
    about: aboutRef,
    services: servicesRef,
    contact: contactRef,
  };

  useEffect(() => {
    const saved = window.localStorage.getItem("themeMode");
    if (saved === "dark" || saved === "light") {
      setThemeMode(saved);
    }
  }, []);

  useEffect(() => {
    window.localStorage.setItem("themeMode", themeMode);
  }, [themeMode]);

  const toggleTheme = () => {
    setThemeMode((current) => (current === "light" ? "dark" : "light"));
  };

  return (
    <ThemeProvider theme={themeMode === "light" ? lightTheme : darkTheme}>
      <GlobalStyle />
      <ScrollToTop />
      <Header
        sectionRefs={sectionRefs}
        themeMode={themeMode}
        toggleTheme={toggleTheme}
      />
      <Home sectionRefs={sectionRefs} />
      <Footer />
    </ThemeProvider>
  );
}

export default App;
